/* quantity selector
   - Initializes quantity selector components with + / - buttons
   - Keeps the original input[name="quantity"] for forms
   - Accessible (aria) and configurable via data-attributes on the .quantity-selector element
   Usage: include this asset on pages with the modified buy-buttons snippet
*/
(function () {
  'use strict';

  // Utility: clamp value between min and max (if max provided)
  function clamp(value, min, max) {
    var v = Number(value) || 0;
    if (min != null) v = Math.max(v, min);
    if (max != null) v = Math.min(v, max);
    return v;
  }

  // Parse integer safely, fallback to fallbackValue
  function parseIntSafe(value, fallbackValue) {
    var n = parseInt(value, 10);
    return isNaN(n) ? fallbackValue : n;
  }

  // Initialize all selectors found in the document
  function initAll() {
    var selectors = document.querySelectorAll('.quantity-selector');
    selectors.forEach(initOne);
  }

  // Initialize a single quantity selector element
  function initOne(el) {
    if (!el) return;
    if (el.__quantitySelectorInitialized) return; // idempotent
    el.__quantitySelectorInitialized = true;

    var input = el.querySelector('input.product-variant-quantity');
    var btnDec = el.querySelector('.quantity-selector__button--decrease');
    var btnInc = el.querySelector('.quantity-selector__button--increase');

    if (!input || !btnDec || !btnInc) return;

    // Configuration via data-attributes on the .quantity-selector wrapper
    var min = parseIntSafe(el.getAttribute('data-quantity-min'), parseIntSafe(input.getAttribute('min'), 1));
    var step = parseIntSafe(el.getAttribute('data-quantity-step'), parseIntSafe(input.getAttribute('step'), 1));
    var maxAttr = input.getAttribute('max');
    var max = maxAttr ? parseIntSafe(maxAttr, null) : null;

    // Keep input.type numeric-friendly
    input.setAttribute('inputmode', 'numeric');
    input.setAttribute('pattern', '[0-9]*');

    // Ensure starting value is valid
    var currentVal = parseIntSafe(input.value, min);
    currentVal = clamp(currentVal, min, max);
    input.value = currentVal;

    // Update UI state (disabled states etc.)
    function updateUI() {
      var val = parseIntSafe(input.value, min);
      val = clamp(val, min, max);
      input.value = val;

      btnDec.disabled = val <= min;
      if (max != null) btnInc.disabled = val >= max;

      // Add classes for styling states
      el.classList.toggle('is-min', val <= min);
      el.classList.toggle('is-max', max != null && val >= max);
    }

    // Change handler for the input - sanitize typed values
    function onInputChange() {
      var val = parseIntSafe(input.value, min);
      if (isNaN(val)) val = min;
      val = clamp(val, min, max);
      input.value = val;
      updateUI();
    }

    // Buttons handler
    function changeBy(delta) {
      var val = parseIntSafe(input.value, min);
      val = clamp(val + delta * step, min, max);
      input.value = val;
      // Trigger input event so any other listeners react
      var evt = new Event('input', { bubbles: true });
      input.dispatchEvent(evt);
      updateUI();
    }

    btnDec.addEventListener('click', function (e) {
      e.preventDefault();
      changeBy(-1);
    });

    btnInc.addEventListener('click', function (e) {
      e.preventDefault();
      changeBy(+1);
    });

    // Keyboard support: allow arrow keys when input focused
    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowUp') {
        e.preventDefault();
        changeBy(+1);
      } else if (e.key === 'ArrowDown') {
        e.preventDefault();
        changeBy(-1);
      }
    });

    // On blur sanitize and clamp
    input.addEventListener('blur', onInputChange);

    // Also handle manual input changes
    input.addEventListener('input', function () {
      // allow temporarily invalid typing, but keep derived state updated lightly
      var raw = input.value.replace(/[^0-9]/g, '');
      if (raw === '') return; // wait for blur maybe
      input.value = raw;
      // nothing else yet; will clamp on blur
    });

    // Initialize UI
    updateUI();
  }

  // Auto-init on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Expose a small API for developers
  window.QuantitySelector = {
    init: initAll,
    initElement: initOne
  };
})();
